<button mat-menu-item (click)="handleMenuAction()">
    <span *ngIf="!caseRequirement.hasDocument; else viewDocumentsTemplate">Add Documents</span>
    <ng-template #viewDocumentsTemplate>Add/View Documents</ng-template>
</button>